import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from '@/layout/components/app.menuitem';

@Component({
    selector: '[app-logo]',
    template: `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="app-logo-normal"
	 viewBox="0 0 304.21 88.51" style="enable-background:new 0 0 304.21 88.51;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#79868D;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}
	.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}
	.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}
	.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}
	.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}
	.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}
	.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}
	.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}
	.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}
	.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}
	.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}
	.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_12_);}
</style>
<g>
	<g>
		<rect x="217.73" y="72.43" class="st0" width="70.2" height="1.5"/>
	</g>
	<g>
		<rect x="9.2" y="72.43" class="st0" width="65.7" height="1.5"/>
	</g>
	<g>
		<path class="st0" d="M83.48,80.84V66.31h1.95v6.23h13.17v-6.23h1.95v14.53h-1.95v-6.68H85.44v6.68H83.48z"/>
		<path class="st0" d="M109.03,75.56v-3.98c0-1.9,0.37-3.26,1.11-4.1c0.8-0.9,2.16-1.35,4.07-1.35h7.87c1.91,0,3.26,0.44,4.05,1.32
			c0.75,0.85,1.12,2.22,1.12,4.12v3.98c0,1.91-0.37,3.27-1.1,4.1c-0.8,0.9-2.16,1.35-4.07,1.35h-7.87c-1.91,0-3.25-0.43-4.03-1.3
			C109.41,78.85,109.03,77.47,109.03,75.56z M125.3,76.3v-5.46c0-1.18-0.33-2.01-0.98-2.49c-0.54-0.4-1.35-0.6-2.43-0.6h-7.48
			c-1.09,0-1.89,0.2-2.41,0.58c-0.67,0.5-1.01,1.33-1.01,2.51v5.46c0,1.18,0.33,2.01,0.99,2.49c0.53,0.41,1.35,0.6,2.43,0.6h7.48
			c1.08,0,1.89-0.19,2.41-0.58C124.96,78.32,125.3,77.48,125.3,76.3z"/>
		<path class="st0" d="M135.42,80.84V66.31l3.07,0.01l8.48,12.19l8.51-12.19l3.08,0v14.53h-1.96V68.07l-8.94,12.76l-1.38,0.01
			l-8.87-12.77l-0.04,12.77H135.42z"/>
		<path class="st0" d="M167.32,80.84V66.31h15.27v1.62h-13.32v4.61h12.84v1.62h-12.84v5.07h13.4v1.62H167.32z"/>
		<path class="st0" d="M191.15,77.33v-1.06h1.84v1.02c0,0.73,0.24,1.27,0.72,1.61c0.47,0.33,1.31,0.5,2.51,0.5h6.63
			c1.43,0,2.4-0.18,2.92-0.56c0.52-0.38,0.79-1.08,0.79-2.13c0-0.91-0.22-1.52-0.65-1.83c-0.43-0.31-1.28-0.46-2.53-0.46h-4.23
			c-3.19,0-5.27-0.22-6.23-0.66c-1.17-0.54-1.75-1.72-1.75-3.55c0-1.6,0.49-2.68,1.49-3.28c0.87-0.52,2.38-0.78,4.54-0.78h4.73
			c2.34,0,3.97,0.31,4.88,0.94c0.81,0.56,1.23,1.53,1.23,2.89v0.51h-1.84c0-1.19-0.26-1.93-0.78-2.23c-0.6-0.33-2.16-0.5-4.67-0.5
			h-2.59c-2.08,0-3.41,0.13-4,0.39c-0.76,0.32-1.15,1.06-1.15,2.2c0,0.91,0.23,1.52,0.69,1.84c0.45,0.32,1.43,0.47,2.93,0.47h6.33
			c1.93,0,3.32,0.28,4.17,0.84c0.85,0.56,1.27,1.48,1.27,2.73v0.95c0,1.25-0.36,2.17-1.07,2.77c-0.83,0.71-2.43,1.06-4.79,1.06
			h-5.97c-1.7,0-2.97-0.21-3.78-0.65C191.69,79.79,191.15,78.78,191.15,77.33z"/>
	</g>
	<g>
		<path class="st0" d="M291.29,56.15h-0.66v-2.89h-1.01v-0.57h2.69v0.57h-1.01V56.15z"/>
		<path class="st0" d="M295.21,56.15h-0.59l-1.1-2.9h-0.01l0.05,2.9h-0.66v-3.46h1.06l0.94,2.57h0.02l0.92-2.57h1.09v3.46h-0.66
			l0.06-2.91h-0.02L295.21,56.15z"/>
	</g>
	<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="147.1207" y1="9.6058" x2="147.1207" y2="55.3918">
    <stop stop-color="var(--p-primary-400)" />
    <stop offset="1" stop-color="var(--p-primary-700)" />
	</linearGradient>
	<polygon class="st1" points="165.67,56.16 147.12,37.49 128.57,56.16 113.58,56.16 147.12,22.6 180.67,56.16 	"/>
</g>
<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="89.7692" y1="8.5746" x2="89.7692" y2="55.0746">
<stop stop-color="var(--p-primary-400)" />
<stop offset="1" stop-color="var(--p-primary-700)" />
</linearGradient>
<rect x="76.08" y="28.03" class="st2" width="27.37" height="9.55"/>
<g>
	
		<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-3272.8284" y1="2851.0298" x2="-3272.8284" y2="2888.6184" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
	</linearGradient>
	<rect x="142.53" y="47.34" class="st3" width="3.76" height="3.76"/>
	
		<linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="-3267.4187" y1="2850.8782" x2="-3267.4187" y2="2888.4683" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
	</linearGradient>
	<rect x="147.95" y="47.34" class="st4" width="3.75" height="3.76"/>
	
		<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="-3272.8284" y1="2851.1694" x2="-3272.8284" y2="2888.7593" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
	</linearGradient>
	<rect x="142.53" y="52.4" class="st5" width="3.76" height="3.76"/>
	
		<linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="-3267.4187" y1="2851.0176" x2="-3267.4187" y2="2888.6086" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
	</linearGradient>
	<rect x="147.95" y="52.4" class="st6" width="3.75" height="3.76"/>
	<g>	
		<polygon class="st7" points="114.19,9.03 129.03,9.03 142.21,22.21 134.79,29.63"/>
		<polygon class="st8" points="152.07,22.17 165.21,9.03 180.05,9.03 159.49,29.59"/>
		<polygon class="st9" points="9.2,56.16 9.2,9.05 20.94,9.05 20.94,46.74 57.71,46.74 57.71,56.16"/>	
		<polygon class="st10" points="61.97,56.16 61.97,9.05 109.51,9.05 109.51,18.45 72.29,18.45 72.29,46.74 109.51,46.74 
			109.51,56.16"/>
		<path class="st11" d="M183.39,56.15l19.99-47.09h14.49l19.99,47.09l-10.68,0.01l-4.55-10.72h-24.01l-4.55,10.72L183.39,56.15z
			 M202.39,36.57h16.48l-8.24-19.42L202.39,36.57z"/>
		<path class="st12" d="M277.75,56.16v-3.65c0-6.26-3.17-9.43-9.42-9.43h-16.5v13.08h-10.4V9.05h33.41c5.07,0,8.41,1.12,10.52,3.53
			c1.84,2.08,2.77,5.41,2.77,9.91v4.35c0,3.24-0.45,5.54-1.38,7.04c-1.16,1.86-3.76,3.8-6.63,4.47l0.04,0.09
			c5.66,1.18,7.93,7.6,7.93,11.79v5.94H277.75z M251.82,34.18h18.95c2.39,0,4.11-0.52,5.25-1.6c1.14-1.09,1.72-2.75,1.72-4.96v-3.28
			c0-2.57-0.72-4.35-2.14-5.3c-1.26-0.84-3.29-1.26-6.21-1.26h-17.57V34.18z"/>  		
			<linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="-3152.4624" y1="2847.2183" x2="-3152.4624" y2="2884.8174" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
            <stop stop-color="var(--p-primary-400)" />
            <stop offset="1" stop-color="var(--p-primary-700)" />
		</linearGradient>
        <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="-3206.614" y1="2848.2708" x2="-3206.614" y2="2886.1472" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
		</linearGradient>
        <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="-3331.4983" y1="2852.2029" x2="-3331.4983" y2="2889.7825" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
		</linearGradient>
        <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="-3383.7834" y1="2853.6655" x2="-3383.7834" y2="2891.2236" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
		</linearGradient>
        <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="-3289.0388" y1="2850.7493" x2="-3289.0388" y2="2888.3452" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
		</linearGradient>
        <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="-3251.1799" y1="2849.3506" x2="-3251.1799" y2="2888.3235" gradientTransform="matrix(1 0 0 1 3417.241 -2839.8918)">
        <stop stop-color="var(--p-primary-400)" />
        <stop offset="1" stop-color="var(--p-primary-700)" />
		</linearGradient>
	</g>
</g>
</svg>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 435.58 306.74" class="app-logo-single h-8">
<defs>
                        <linearGradient id="paint0_linear" x1="0" y1="0" x2="435" y2="306" gradientUnits="userSpaceOnUse">
                            <stop stop-color="var(--p-primary-400)" />
                            <stop offset="1" stop-color="var(--p-primary-700)" />
                        </linearGradient>
                    </defs>
                <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1">
                    <path fill="url(#paint0_linear)" d="M434.94,306.71h-2.11q-46.63,0-93.27,0c-1.59,0-2.81-.19-3.51-1.82-.24-.56-.88-.94-1.35-1.41q-22.77-22.78-45.55-45.57-35.06-35.19-70-70.45c-.56-.57-1.07-1.19-1.9-2.14-1,1.15-1.77,2.19-2.68,3.1-10.64,10.67-21.33,21.3-32,32q-36.1,36.29-72.17,72.62c-4.09,4.12-8,8.38-12.14,12.49a4.07,4.07,0,0,1-2.58,1.12q-47.29.09-94.59,0H0L217.31,89.4,435.58,305.78Z"/>
                    <path fill="url(#paint0_linear)" d="M3,0H5.91Q52,0,98.07,0a4.84,4.84,0,0,1,3.77,1.59q40.88,41,81.82,81.87c2.42,2.41,2.42,2.41-.08,4.91q-22.23,22.23-44.45,44.5c-1.3,1.31-2,1.48-3.45.07Q70.26,67.41,4.77,2C4.31,1.51,3.89,1,3,0Z"/>
                    <path fill="url(#paint0_linear)" d="M431.78.66,298,134.46,249.66,86.12a14.76,14.76,0,0,1,1.7-2.56q41-41,82-82A4.58,4.58,0,0,1,336.9,0q46.2.08,92.38,0h2.25Z"/>
                    <path fill="url(#paint0_linear)" d="M212.13,273.85H187.52V248.8h24.61Z"/>
                    <path fill="url(#paint0_linear)" d="M222.52,248.7h24.59v25.13H222.52Z"/>
                    <path fill="url(#paint0_linear)" d="M187.51,306.57V281.93h24.62v24.64Z"/>
                    <path fill="url(#paint0_linear)" d="M247.19,282v24.53H222.5V282Z"/>
                </g>
            </g>
        </svg>
    `,
})
export class AppLogo {
    
}
